export default function CenteredLayout({children}){
    return (
        <div className="flex flex-col items-center justify-center h-screen">
            {children}
        </div>
    );
}